import { TYPES } from "./job.type";

const initState = {
  all: null,
  jobList: null,
  userList: null,
  income: null,
  detail: null,
};

const jobReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ALL_JOB_SUCCESS:
      return {
        ...state,
        all: payload,
      };
    case TYPES.GET_JOB_LIST_SUCCESS:
      return {
        ...state,
        jobList: payload,
      };
    case TYPES.SELECT_ALL_INCOME_SUCCESS:
      return {
        ...state,
        income: payload,
      };
    case TYPES.GET_STAFF_BY_IDS_SUCCESS:
      return {
        ...state,
        userList: payload,
      };
      case TYPES.GET_JOB_DETAIL_BY_ID_SUCCESS:
        return {
          ...state,
          detail: payload,
        };
    default:
      return state;
  }
};

export default jobReducer;
